import { Adapter } from './adapter';
import { SessionDates } from '../models/_index';
import { SessionDatesInterface } from '@app/interfaces/_index';

/**
 * Adapts raw service from Docebo session dates object to a Session Dates Model
 * NOTE: The item fields are the default json property names.
 */
export class SessionDatesAdapter implements Adapter<SessionDates> {
  /**
   * Session dates Object response interface is used to display Sessison response from the DLP Lambdas
   * @param item has Session dates object response Session Dates Interface
   * @returns - adapted session dates object to Session Dates object model
   */
  adapt(item: SessionDatesInterface): SessionDates {
    let sessionDates: SessionDates;
    if (item) {
      sessionDates = new SessionDates(
        item.date,
        item.name,
        item.effective_duration,
        item.end_hour,
        item.gmt,
        item.id_classroom,
        item.id_location,
        item.start_hour,
        item.timezone
      );
    }
    return sessionDates;
  }
}
